export const environment = {
  production: false,
  organizationWebVersionReferenceKey: "WebApp.OrganizationVersion",
  whatsAppApi: 'https://test-whatsapp-api.nibo.com.br',
  datadog: {
    env: "test",
    clientToken: "pubce1f8c0fe279ef8dec501d82cf52f637",
    site: "datadoghq.com"
  },
  sources: {
    goNibo: 'https://go.nibo.com.br',
    accountantApi: 'https://test-api-contador.nibo.com.br'
  },
  azure: {
    whitelabel: {
      androidLogicApp: 'https://prod-21.brazilsouth.logic.azure.com:443/workflows/6c2226e814e2414ba05d72b80c4df3d1/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=erNxyhfNU1JIptK_XZ3ZFCpGPIecvK_iOwRlTcugNzI',
      iosLogicApp: 'https://prod-20.brazilsouth.logic.azure.com:443/workflows/e3ad280394594462b469864f94b02bce/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LBTwR_2BrXm28St3MA0Ar-FQe6pTidjcAo7iI1cc1lY',
      storageEndpoint: 'https://brniboappwhitelabel.blob.core.windows.net',
      container: 'accountant-assets-test',
      qrCodesContainer: 'qrcodes-test',
      api: 'https://br-nibo-customer-app-whitelabel-functions-test.azurewebsites.net/api'
    },
    subscriptionId: "835c1969-3f09-41da-a88d-203354dc2b04",
    environments: {
      testServer: {
        resourceGroupName: "br-nibo-testserver-rg",
        accountantContext: {
          appServicePlanName: "br-nibo-testserver-asp-accountant"
        },
        organizationContext: {
          appServicePlanName: "br-nibo-testserver-asp-organization"
        }
      },
      pulumi: {
        resourceGroupName: "br-nibo-pulumi-rg"
      }
    }
  },
  azureDevops: {
    organization: "nibogestao",
    principalProject: "NiboProjects",
    organizationWebRepositoryId: "328f9cfc-cb22-46cb-96e6-ad50509dd0e0"
  }
}
